export const ApiUrls = {
  publicConfig: '/config/public', // LIKE COUNTRY LIST ETC
  getCountrie: '/master/country', // LATER ADDED
  getStates: '/master/states',
  getCities: '/master/cities',

  sendOtpRequest: '/auth/otp/request',
  forgotPassword:'/auth/forgot-password',
  verifyOtpRequest: '/auth/otp/check',
  loginAs : '/auth/impersonations/token',

  registerUser: '/auth/register/user',
  applogin: '/auth/login',
  getAccessTokenFromRefreshToken :'/auth/token/refresh',
  forgotResetPassowrd: '/auth/reset_password',
  getEmailFromOtpRequestId: `/auth/email/`,

  getProfile: '/profile',
  getLanguages: '/languages',
  updateLanguage: '/profile/lang_pref',
  updateMyProfile: '/profile',
  updateMyPassword: '/profile/change_password',

  organization: '/organization',

  getOrgRoles: '/org-roles',
  addNewOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED
  updateOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  getOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  deleteOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  getOrgRoleOption: '/org-roles/role-option', // BEFORE THIS ORG_ID IS REQUIRED
  authItems:'/org-roles/auth-items',

  getOrgUsers: '/org-users',
  addNewOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED
  updateOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  getOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  deleteOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  reinviteOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED

  // DASHBOARD:
  getDashboard:'/dashboard',
  dashboardToken:'/token',
  getAlerts:'/alerts',

  getPartners:'/partners',
  getCustomers:'/customers',
  sendInvite:'/send-invite',
  getAssets:'/asset-hierarchy',

  // Reports:
  getReports:'/trends/',
  customers:"/customers/",
  devices:"/devices",
  gateway_devices:"/gateway-devices",
  sensors:"/sensors/",
  device:"/devices/",
  relational_assets:"/relational-assets",

  getProjects: '/{orgId}/projects',
  getProjectDetail: '/{orgId}/projects/{projectId}',
  addNewProject: '/{orgId}/projects',
  updateProject: '/{orgId}/projects/{projectId}',
  deleteProject: '/{orgId}/projects/{projectId}',
  projectTeamList: '/{orgId}/projects/{projectId}/teams',
  projectUserList: '/{orgId}/projects/{projectId}/users',
  projectUsersMapping: '/{orgId}/projects/{projects}/teams',
  projectRemoveUser: '/{orgId}/projects/{projectId}/teams/{userMappingId}',
};
